/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Loading_ElapsedInputs */

const en_loading_elapsed = /** @type {(inputs: Loading_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} seconds in this view`)
};

const id_loading_elapsed = /** @type {(inputs: Loading_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} detik menunggu di halaman ini`)
};

/**
* | output |
* | --- |
* | "{seconds} seconds in this view" |
*
* @param {Loading_ElapsedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_elapsed = /** @type {((inputs: Loading_ElapsedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_ElapsedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_elapsed(inputs)
	return en_loading_elapsed(inputs)
});